export const SET_USER = 'user/SET_USER';
export const SET_USER_ROLE = 'user/SET_USER_ROLE';
export const SET_USER_FULLNAME = 'user/SET_USER_FULLNAME';
export const SET_DEMO_MODE = 'user/SET_DEMO_MODE';
export const SET_ACCOUNTS = 'user/SET_ACCOUNTS';
export const SET_ACCOUNT_ID = 'user/SET_ACCOUNT_ID';
export const SET_COMPANY_NAME = 'user/SET_COMPANY_NAME';
export const SET_ACCOUNT_SETTINGS = 'user/SET_ACCOUNT_SETTINGS';
export const SET_ACCOUNT_USAGE = 'user/SET_ACCOUNT_USAGE';
// Note: billing is now in the billing slice (state.billing), use setBilling from billing/actions
// Note: tags are now in the tags slice (state.tags.tags), use setTags from tags/actions
export const SET_DEFAULT_UNIT = 'user/SET_DEFAULT_UNIT';
export const SET_IS_PHONE_VERIFIED = 'user/SET_IS_PHONE_VERIFIED';
export const SET_USER_PROFILE = 'user/SET_USER_PROFILE';
export const LOGOUT = 'user/LOGOUT';
export const LOGIN = 'user/LOGIN';
